import React, { createContext, useContext, useState } from 'react';

// Create context
const TicketContext = createContext(null);

/**
 * Provider component for ticket data
 * @param {Object} props - Component props
 * @returns {JSX.Element} Provider component
 */
export const TicketProvider = ({ children }) => {
  const [ticketInfo, setTicketInfo] = useState(null);
  
  return (
    <TicketContext.Provider value={{ ticketInfo, setTicketInfo }}>
      {children}
    </TicketContext.Provider>
  );
};

/**
 * Custom hook to use the ticket context
 * @returns {Object} Ticket context value
*/
export const useTicketContext = () => {
  const context = useContext(TicketContext);
  
  if (!context) {
    throw new Error('useTicketContext must be used within a TicketProvider');
  }
  
  return context;
};

export default TicketContext;
